// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_aj-0";